import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { setImmunizationStatusOptions } from '../store/options.actions'

export function* getImmunizationStatusOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getImmunizationStatusOptions,
    ])
    const { entity } = response
    yield put(setImmunizationStatusOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getImmunizationStatusOptions() error: ${e}`))
  }
}

export function* getImmunizationStatusOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getImmunizationStatusOptions)
}
